import { runInAction } from 'mobx';
// import { post, getUrlParam, get } from '../utils';
import { post } from '../utils';
import {  setCookie, getCookie, setParamsHeaders } from '../utils';

import { toast } from '../components';
import store from '../store';

// 请求游戏登陆接口
function gameLogin() {
    let openid = store.status.openId || '977d88c7f7d8d8b567f82c08285dc38d';
    post('user/v1/game/login', {openid: openid}).then((res) => {
        if(res.errCode == 200){
            runInAction(() => {
                let partnerId = res.data && res.data.partnerId ? res.data.partnerId : 'wxs9FQ9mBfYfelaugNYZ-A';
                window.sessionStorage.setItem('__partnerId', partnerId);
                setCookie('pub-token', res.data.token, 720);
                setParamsHeaders({
                    accountType: 3,
                    osType: 3,
                    'pub-token': getCookie('pub-token')
                });
                store.user.partnerId = partnerId;
                store.user.setPartnerId();
                store.user.fetch();
                store.user.shopNum();
                store.user.getShopName();
                return store.user.add();
            })
        }else{
            window.location.href = '#!/gameLogin?gameApp=true';
        }
    }).catch((res) => {
        toast(res.errMsg);
        window.location.href = '#!/gameLogin?gameApp=true';
    })
}



export default gameLogin;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/operates/gameLogin.ts